import React from 'react';
import { Menu } from 'antd';

export const Sidenav = ({
  selectedItem,
  children,
}: React.PropsWithChildren<{ selectedItem: string | undefined }>) => (
  <>
    <Menu
      className="Sidenav"
      theme="dark"
      selectedKeys={[selectedItem!]}
      mode="inline"
    >
      {children}
    </Menu>
    <style jsx global>{`
      // make menu follow zero width of collapsed Sider
      .Sidenav.ant-menu-inline-collapsed {
        width: 0px;
      }
    `}</style>
  </>
);
